import http from "./http";

class EditeursService {
    index(){
        return http.get("/api/editeurs")
    }

    store(data,token){
        return http.post("/api/editeurs/store", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    edit(id,token){
        return http.get(`/api/editeurs/${id}/edit`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return http.get(`/api/editeurs/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(id, data,token){
        return http.post(`/api/editeurs/${id}/update`, data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return http.delete(`/api/editeurs/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new EditeursService()